module.exports = __webpack_public_path__ + "img/partnerzy-02_ongeo_services.26e309b2.svg";